import CreationBody from 'components/CreateQuiz/CreationBody';

const Desktop = () => <CreationBody device={'desktop'} />;

export default Desktop;
